import { fetchContext, type TRouteWithRedirect } from "@sphtech/web2-core/ssr";
import logger from "@src/logger/Logger";
import { type ClientLoaderFunctionArgs } from "react-router";

export default async function fetchContextWithFallback<T>(
  args: ClientLoaderFunctionArgs,
): Promise<TRouteWithRedirect<T, string>> {
  const result = (await fetchContext(args)) as { context?: unknown };

  if (!result.context) {
    logger.error(
      "Error occurred during client-side routing, returning server Loader Data",
    );
    return await args.serverLoader();
  }

  return result.context as TRouteWithRedirect<T, string>;
}
